import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Card, CardContent, Checkbox, CircularProgress, Dialog, DialogActions, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Input, InputLabel, Link, List, ListItem, ListItemText, MenuItem, Paper, Select, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import APIManager from '../../lib/apiManager';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { Stack } from '@mui/material';
import { sistema } from '../../model/Sistema';
import { CheckBox, CheckCircle, DoneAll, ExpandMore as ExpandMoreIcon, PublishedWithChanges, RemoveDone, Search } from "@mui/icons-material";
import InfoIcon from '@mui/icons-material/Info';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Tooltip from '@mui/material/Tooltip';
import PuestoSquare from "./components/PuestoSquare";
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';   // opcional, para el centro de la mesa
import ConfirmacionReserva from "./components/Confirmacion";


const NuevaReserva = ({ setBotonera, espacios, espacio, usuario }) => {
  const semanaCompleta = [true, true, true, true, true, true, true];

  const [habilitadoParaGuardar, setHabilitadoParaGuardar] = useState(false);
  const [reservas, setReservas] = useState([]);
  const [asignadosPosibles, setAsignadosPosibles] = useState([]);
  const [textoDeBusqueda, setTextoDeBusqueda] = useState(sistema?.actual?.textoDeBusqueda ?? '');
  const [loadingAsignadosPosibles, setLoadingAsignadosPosibles] = useState(true);

  const [espaciosDisponibles, setEspaciosDisponibles] = useState(espacios);

  const [espacioSeleccionado, setEspacioSeleccionado] = useState(sistema?.actual?.espacio ?? espacio);
  const [fechaUnica, setFechaUnica] = useState(true);
  const [fechaDesde, setFechaDesde] = useState(new Date().toISOString().substring(0, 10)); // Comienza con el dia de hoy
  const [fechaHasta, setFechaHasta] = useState(new Date().toISOString().substring(0, 10)); // Comienza con el dia de hoy
  const [semana, setSemana] = useState(semanaCompleta); // Comienza con todos los dias de la semana marcados
  const [semanaChecked, setSemanaChecked] = useState(true);
  const [semanaDisponible, setSemanaDisponible] = useState(semanaCompleta);

  const [diaDePrueba, setDiaDePrueba] = useState(false);
  const [emailDePrueba, setEmailDePrueba] = useState('');

  const [saldoDisponible, setSaldoDisponible] = useState(0);
  const [costoUnitario, setCostoUnitario] = useState(0);
  const [costoTotal, setCostoTotal] = useState(0);

  const tiposDeUbicacion = [
    { value: 'puesto', label: 'Puesto' },
    // { value: 'sala', label: 'Espacio Privado' },
    // { value: 'callroom', label: 'CallRoom' },
    // { value: 'cine', label: 'Cine' },
  ];

  const turnos = [
    { value: 'MORNING', label: 'Mañana' },
    { value: 'AFTERNOON', label: 'Tarde' },
    { value: 'DOBLE', label: 'Doble'},
  ]

  const [tipoDeUbicacion, setTipoDeUbicacion] = useState(sistema?.actual?.tipoDeUbicacion ?? 'puesto');
  const [fechas, setFechas] = useState(sistema?.actual?.fechas ?? []);
  const [turno, setTurno] = useState(sistema?.actual?.turno ?? 'MORNING');
  const [puestos, setPuestos] = useState(sistema?.actual?.puestos ?? []);
  const [horaInicial, setHoraInicial] = useState(sistema?.actual?.horaInicial ?? null);
  const [duracion, setDuracion] = useState(sistema?.actual?.duracion ?? null);
  const [miembro, setMiembro] = useState(null);
  const [empresa, setEmpresa] = useState(null);
  const [usuarioAsignado, setUsuarioAsignado] = useState(null);

  const [disponibles, setDisponibles] = useState([]);
  const [sectores, setSectores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [habilitadoParaBuscar, setHabilitadoParaBuscar] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);

  const botoneraDeReserva = [
    { title: 'Guardar', label: 'Guardar', variant: 'contained', visible: true, disabled: !habilitadoParaGuardar, onClick: () => { handleGuardar(); } },
    { title: 'Cancelar', label: 'Cancelar', variant: 'contained', visible: true, onClick: () => { handleCancelar(); } },
  ];

  const navigate = useNavigate();

  const calcularFechas = () => {
    // Arma el listado de fechas correspondientes a los dias de la semana seleccionados dentro del rango de fechas
    const desde = moment(fechaDesde);
    const hasta = moment(fechaHasta);
    let actual = desde;
    const dias = [];
    while (actual <= hasta) {
      if (!!semana[actual.day()]) {
        dias.push(actual.clone());
      }
      actual.add(1, 'days');
    }
    setFechas(dias);
  }

  const cargarAsignadosPosibles = (data) => {
    setLoadingAsignadosPosibles(true);
    setAsignadosPosibles([]);
    // Cargamos todos los miembros y empresas (clientes) existentes y activos
    APIManager.getList('asignadosPosibles', {nombre: textoDeBusqueda}, response => {
      if (response.success) {
        setAsignadosPosibles(response.data.listado.map(item => {
          item.uid = item.tipo[1] + item.id;
          return item;
        }));
        setLoadingAsignadosPosibles(false);
      }
    })
    return data;
  }

  const guardarReserva = () => {
    APIManager.sendRequest('post', 'reservas', 'crearReservas', { usuario: { id: usuarioAsignado.usuario_id }, reservas: reservas }, (response) => {
      if (response.success) {
        setHabilitadoParaGuardar(false);
        setReservas([]);
        // Pop-up de success
        // Volver al listado de reservas
        navigate(-1);
      }
    });

  }

  const handleEspacio = (espacioActual) => {
    setEspacioSeleccionado(espacioActual);
  }

  const handleFechaUnica = (event) => {
    setFechaUnica(event.target.checked);
  }

  const handleDiaDePrueba = (event) => {
    setDiaDePrueba(event.target.checked);
  }

  const handleEmailDePrueba = (event) => {
    setEmailDePrueba(event.target.value);
  }

  const handleFecha = (event) => {
    // Fecha unica
    setFechaDesde(event.target.value);
    setFechaHasta(event.target.value);
  }

  const handleFechaDesde = (event) => {
    setFechaDesde(event.target.value);
  }

  const handleFechaHasta = (event) => {
    setFechaHasta(event.target.value);
  }

  const handleDia = (dia) => {
    setSemana(semana.map((value, index) => index == dia ? !value : value));
    setSemanaChecked(semana.every(dia => dia));
  }

  const handleSwapSemana = () => {
    setSemana(semana.map(val => !val));
  }

  const handleCheckSemana = () => {
    if (!semanaChecked) {
      // setSemana(semana.map(val => true)); // Pone todos los dias tildados
      setSemana(semanaDisponible.map(val => val)); //Pone los disponibles del espacio
      setSemanaChecked(true);
    } else {
      setSemana(semana.map(val => false));
      setSemanaChecked(false);
    }
  }

  const handleUncheckSemana = () => {
    setSemana(semana.map(val => false));
  }


  const handleAsignadoKeyUp = (event) => {
    if (event.code === 'Enter') {
      // Hay que buscar
      cargarAsignadosPosibles(textoDeBusqueda);
    }
  }

  const handleAsignado = (event, item) => {
    if (!!item) {
      APIManager.sendRequest('post', 'usuario', 'getUsuario', { conContrato: true, conMembresia: true, usuarioID: item.usuario_id }, response => {
        if (response.success) {
          item.usuario = response.data.usuario;
        }
        setUsuarioAsignado(item);
      })
    } else {
      setUsuarioAsignado(item);
    }
  }

  const handleToggleMesa = (mesa) => {
    const puestosSeleccionados = puestos.filter(puesto => puesto.desk_id === mesa.id);
    const puestosDisponibles = mesa.puestos.filter(puesto => puesto.habilitado && puesto.status == 'FREE');
    const puestosNoSeleccionados = puestosDisponibles.filter(puesto => !puestosSeleccionados.find(item => item.id == puesto.id));

    if (puestosDisponibles.length == puestosSeleccionados.length) {
      // Des-selecciona todos
      setPuestos((prev) => prev.filter(puesto => puesto.desk_id !== mesa.id));
    } else {
      // Selecciona todos que faltan
      setPuestos((prev) => [...prev, ...puestosNoSeleccionados.map(puesto => {
        return { ...puesto, desk_id: mesa.id, mesaNombre: mesa.nombre }
      })]);
    }
  }

  const handleTipoDeUbicacion = (event) => {
    setTipoDeUbicacion(event.target.value);
  }

  const handleTurno = (event) => {
    setTurno(event.target.value);
  }

  const handleBuscar = (event) => {
    actualizarDisponibles();
  }

  const handleGuardar = (event) => {
    setOpenDialog(true);
  }

  const handleConfirmar = () => {
    handleClose();
    guardarReserva();
  }

  const handleClose = () => {
    setOpenDialog(false);
  }

  const handleCancelar = (event) => {
    navigate(-1); // Cancelar solo sale de la pantalla
  }

  const verificarHabilitadoParaGuardar = () => {
    setHabilitadoParaGuardar(!!espacioSeleccionado && !!usuarioAsignado && (fechas.length > 0) && (disponibles.length > 0) && (puestos.length > 0) && (costoTotal <= saldoDisponible) && (!diaDePrueba || !!(emailDePrueba.toLowerCase().trim() ?? '')));
    switch (tipoDeUbicacion) {
      case 'puesto':
        const lista = [];
        const usuarioDeReserva = { ...usuarioAsignado };
        if (!!diaDePrueba) {
          usuarioDeReserva.emailDeContacto = emailDePrueba.toLowerCase().trim();
          usuarioDeReserva.usuario_id = usuario.id;
        }
        fechas.forEach(fecha => puestos.forEach(puesto => {
          lista.push({
            puesto: puesto,
            mesa: disponibles.find(item => item.desk_id == puesto.desk_id),
            turno: { codigo: turno, nombre: turnos.find(item => item.value == turno).label },
            usuario: { id: usuarioDeReserva.usuario_id, emailDeContacto: usuarioDeReserva.emailDeContacto },
            usuarioAsignado: { ...usuarioDeReserva },
            espacio: espacioSeleccionado,
            esDiaDePrueba: diaDePrueba,
            fecha: fecha,
          });
        }));
        setReservas(lista);
        break;
    }
  }

  const actualizarDisponibles = () => {
    const data = {
      paraV1: true,
      activos: true,
      tipoDeUbicacion,
      fechas: fechas,
      espacioID: espacioSeleccionado.id,
      turno: {codigo: turno},
      horaInicial, duracion
    };
    setLoading(true);
    // APIManager.getList('escritorios', data, response => {
    APIManager.sendRequest('post', 'ui', 'getEscritorios', data, response => {
      if (response.success) {
        setDisponibles(response.data);
      }
      setLoading(false);
    })
  }

  const fechaDisponible = (fechaAVerificar) => {
    // Devuelve si la fecha esta disponible
    const hoy = new Date();
    hoy.setHours(0,0,0,0);
    const aMoment = moment(fechaAVerificar);

    // Preliminar: Devolvemos true si es hoy, futuro y no es domingo
    //return aMoment.isSameOrAfter(hoy) && (aMoment.day() !== 0) /*domingo*/

    // Final: Devolvemos true si es hoy, futuro y dia de la semana permitido para el espacio
    const esHoyOFuturo = aMoment.isSameOrAfter(hoy);
    const permitidoEnEspacio = espacioSeleccionado?.horario?.semana[aMoment.day()] ?? true;
    // Ademas revisamos que se encuentre permitido por la membresia
    const permitidoEnMembresia = !usuarioAsignado?.usuario?.membresia?.restricciones || !usuarioAsignado?.usuario?.membresia?.restricciones?.diasDeLaSemana || usuarioAsignado?.usuario?.membresia?.restricciones?.diasDeLaSemana[aMoment.day()];
    return esHoyOFuturo && permitidoEnEspacio && permitidoEnMembresia;
  }

  useEffect(() => {
    // Al cambiar semana o rango de fechas, recalcula todos los dias correspondientes
    // Si es fecha unica, pone fechaHasta igual a fechaDesde
    calcularFechas();
  }, [fechaDesde, fechaHasta, semana]);

  useEffect(() => {
    if (!!fechaUnica) {
      setSemana(semanaDisponible.map(val => val));
      setFechaHasta(fechaDesde);
    }
  }, [fechaUnica]);

  useEffect(() => {
    if (!!diaDePrueba) {
      setUsuarioAsignado({ ...usuario, usuario_id: usuario.id });
    } else {
      setUsuarioAsignado(null);
    }
  }, [diaDePrueba]);

  useEffect(() => {
    // Hubo actualizacion
    verificarHabilitadoParaGuardar();
  }, [espacioSeleccionado, fechas, puestos, saldoDisponible, costoTotal, diaDePrueba, emailDePrueba]);

  useEffect(() => {
    // Si algo de lo pre-seleccionado no existe disponible, lo quitamos
    setPuestos(puestos.filter(puesto => disponibles.some(disp => (disp.desk_id === puesto.desk_id)
      && disp.puestos.find(item => item.id === puesto.id)?.habilitado)));
  }, [disponibles]);

  useEffect(() => {
    // Hubo actualizacion
    sistema.actual.espacioSeleccionado = espacioSeleccionado;
    sistema.actual.usuarioAsignado = usuarioAsignado;
    sistema.actual.fechaDesde = fechaDesde;
    sistema.actual.fechaHasta = fechaHasta;
    sistema.actual.semana = semana;
    sistema.actual.fechas = fechas;
    sistema.actual.puestos = puestos;
    sistema.actual.turno = turno;
    sistema.actual.reservas = reservas;
    sistema.actual.disponibles = disponibles;
    setBotonera(botoneraDeReserva);
    }, [habilitadoParaGuardar, espacioSeleccionado, fechas, usuarioAsignado, puestos, turno, reservas, disponibles]);

  useEffect(() => {
    let habilitado = true;
    switch (tipoDeUbicacion) {
      case 'puesto':
        habilitado = !!turno;
        break;
      case 'sala':
        habilitado = !!horaInicial && !!duracion;
        break;
      default:
        break;
    }
    setHabilitadoParaBuscar(!!habilitado && (fechas.length > 0) && !!usuarioAsignado);

  }, [fechas, turno, horaInicial, duracion, tipoDeUbicacion]);

  useEffect(() => {
    // Obtener saldo disponible
    if (!!usuarioAsignado) {
      APIManager.sendRequest('post', 'usuario', 'getSaldo', { usuarioID: usuarioAsignado.usuario_id }, response => {
        if (response.success) {
          setSaldoDisponible(response.data.amount);
        }
      })
    } else {
      setSaldoDisponible(0);
    }
  }, [usuarioAsignado]);

  useEffect(() => {
    // Calculo de costo unitario
    switch (tipoDeUbicacion) {
      case 'puesto':
        setCostoUnitario(turno === 'DOBLE' ? 3 : 2);
        break;
      default:
        setCostoUnitario(0);
        break;
    }
  }, [tipoDeUbicacion, turno]);

  useEffect(() => {
    // Reset de disponibles
    setDisponibles([]);
    setPuestos([]);
  }, [tipoDeUbicacion, turno, fechas, espacioSeleccionado]);

  useEffect(() => {
    // Calculo del costo total
    setCostoTotal(costoUnitario * puestos.length * fechas.length);
  }, [costoUnitario, puestos, fechas]);

  useEffect(() => {
    // Ajusta los dias de la semana elegibles
    const sem = semanaCompleta.map((val, index) => {
      if (!!espacioSeleccionado?.horario?.semana) {
        val = espacioSeleccionado.horario.semana[index] ?? val;
      }
      if (!!usuarioAsignado?.usuario?.membresia?.restricciones?.diasDeLaSemana) {
        val = val && usuarioAsignado.usuario.membresia.restricciones.diasDeLaSemana[index];
      }
      return val;
    });
    setSemanaDisponible(sem);
    setSemana(sem);
  }, [espacioSeleccionado, usuarioAsignado]);

  useEffect(() => {
    const sectoresDisponibles = Object.entries(
      disponibles.reduce((acc, mesa) => {
        const sectorNombre = mesa?.sector?.nombre ?? 'Sin sector';
        if (!acc[sectorNombre]) acc[sectorNombre] = [];
        acc[sectorNombre].push(mesa);
        return acc;
      }, {})
    ).sort(([a, a2], [b, b2]) => a < b ? -1 : 1);
    sistema.actual.sectores = sectoresDisponibles;
    setSectores(sectoresDisponibles);
  }, [disponibles]);

  useEffect(() => {
    // Cargamos los espacios
    APIManager.getList('espacios', { orderBy: 'nombre', active: true }, (response) => {
      if (response.success) {
        setEspaciosDisponibles(response.data.listado);
      }
    });

    verificarHabilitadoParaGuardar();
  }, []);

  return (
    <Paper sx={{ padding: '14px' }}>
      {!!openDialog && <ConfirmacionReserva open={openDialog} onClose={handleClose} onConfirm={handleConfirmar}
        reservas={reservas} costoTotal={costoTotal} />}
      <Grid container spacing={2}>
        <Grid item sm={4}>
          <Autocomplete
            id="espacio-select"
            value={espacioSeleccionado}
            onChange={(e,item) => handleEspacio(item)}
            options={espaciosDisponibles}
            disabled={espaciosDisponibles.length < 2}
            getOptionLabel={item => item?.nombre ?? ''}
            isOptionEqualToValue={(option, value) => value?.id == option?.id}
            renderInput={(params) =>
              <TextField required variant="standard" {...params} label="Espacio" />
            }
            title={espacio?.nombre ?? ''}
          />
        </Grid>
        <Grid item sm={2}>
          <FormControlLabel sx={{mt: 1}} label='Día de prueba' control={<Checkbox checked={diaDePrueba} onChange={handleDiaDePrueba} />}></FormControlLabel>
        </Grid>
        {!!diaDePrueba
          ? <Grid item sm={6}>
            <TextField fullWidth variant="standard" type="email" label="Email de invitado al día de prueba" value={emailDePrueba} onChange={handleEmailDePrueba} />
          </Grid>
          : <Grid item sm={6}>
            <Autocomplete
              id="asignado-select"
              value={usuarioAsignado}
              onChange={handleAsignado}
              options={asignadosPosibles}
              onInputChange={(event, text) => setTextoDeBusqueda(text)}
              onKeyUp={handleAsignadoKeyUp}
              loading={loadingAsignadosPosibles}
              autoComplete
              // filterOptions={x => x}
              filterSelectedOptions
              getOptionLabel={item => item ? (item?.tipo + ' - ' + item?.descripcion) : ''}
              isOptionEqualToValue={(option, value) => value?.uid == option?.uid}
              renderInput={(params) =>
                <TextField required error={!usuarioAsignado?.usuario?.membresia} helperText={!!usuarioAsignado ? 'Membresía:' + (usuarioAsignado?.usuario?.membresia?.nombre ?? 'Sin Membresía') : ''} variant="standard" {...params} label="Asignar a" />
              }
              title={usuarioAsignado?.descripcion ?? textoDeBusqueda}
            />
          </Grid>
        }
        <Grid item sm={2}>
          <FormControlLabel label='Fecha unica' control={<Checkbox checked={fechaUnica} onChange={handleFechaUnica} />}></FormControlLabel>
        </Grid>
        <Grid item container spacing={2} sm={8}>
          {!!fechaUnica
            ? <Grid item sm={2}>
              <TextField fullWidth variant="standard" required
                label="Fecha"
                value={fechaDesde}
                error={!fechaDisponible(fechaDesde)}
                helperText={!fechaDisponible(fechaDesde) ? moment(fechaDesde).format('ddd') + ' no habilitado' : ''}
                type="date"
                inputProps={{min: new Date().toISOString().substring(0, 10)}}
                onChange={handleFecha}
              />
            </Grid>
            : <>
              <Grid item sm={2}>
                <TextField fullWidth variant="standard" required
                  label="Fecha desde"
                  value={fechaDesde}
                  type="date"
                  inputProps={{min: new Date().toISOString().substring(0, 10)}}
                  onChange={handleFechaDesde}
                />
              </Grid>
              <Grid item sm={2}>
                <TextField fullWidth variant="standard" required
                  label="Fecha hasta"
                  value={fechaHasta}
                  error={moment(fechaHasta) < moment(fechaDesde)}
                  type="date"
                  inputProps={{min: fechaDesde}}
                  onChange={handleFechaHasta}
                />
              </Grid>
              <Grid item sm={6}>
                {semana.map((checked, index) =>
                  <FormControl>
                    <FormLabel sx={{textAlign: 'center'}}>{moment().day(index).format('ddd')}</FormLabel>
                    <Checkbox checked={checked} disabled={!semanaDisponible[index] } onChange={() => handleDia(index)} />
                  </FormControl>
                )}
                <FormControl>
                  <FormLabel sx={{textAlign: 'center'}}><DoneAll fontSize="1em" sx={{alignContent: 'center'}} /></FormLabel>
                  <Checkbox checked={semana.every(dia => dia)} indeterminate={!semana.every(dia => dia) && !semana.every(dia => !dia)} onChange={handleCheckSemana} />
                </FormControl>
              </Grid>
              {/* <Grid item sm={2}>
                <IconButton onClick={handleSwapSemana}><PublishedWithChanges /></IconButton>
                <IconButton onClick={handleCheckSemana}><DoneAll /></IconButton>
                <IconButton onClick={handleUncheckSemana}><RemoveDone /></IconButton>
              </Grid> */}
            </>
          }
        </Grid>
        {!fechaUnica && <Grid item sm={12}>
          <Paper variant="outlined" sx={{ padding: '10px', position: 'relative' }}>
            <Typography position='absolute' top='-0.85em' bgcolor='white' paddingX={1}>{fechas.length + ' Fechas'}</Typography>
            <List sx={{maxHeight: '8em', overflow: 'auto', display: 'flex', flexWrap: 'wrap'}}>
              {fechas.map(fecha =>
                <ListItem sx={{width: 'auto'}}>
                  <Typography>{moment(fecha).format('L ddd')}</Typography>
                </ListItem>
              )}
            </List>
          </Paper>
        </Grid>}
        <Grid item container sm={12}>
          <Grid item sm={2}><Typography color={costoTotal > saldoDisponible ? 'red' : 'green'}>{'Costo: ' + costoTotal}</Typography></Grid>
          <Grid item sm={2}><Typography color={costoTotal > saldoDisponible ? 'red' : 'green'}>{'Saldo disponible: ' + saldoDisponible}</Typography></Grid>
        </Grid>
        <Grid item sm={2} display='flex' flexDirection='row'>
          {/* Tipo de ubicacion puesto/sala */}
          <FormControl variant="standard" fullWidth>
            <InputLabel>Tipo de Ubicación</InputLabel>
            <Select value={tipoDeUbicacion} onChange={handleTipoDeUbicacion}>
              {tiposDeUbicacion.map(tipo => <MenuItem key={tipo.value} value={tipo.value}>{tipo.label}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>
        {(tipoDeUbicacion == 'puesto') && <>
          <Grid item sm={2}>
            <FormControl variant="standard" fullWidth>
              <InputLabel>Turno</InputLabel>
              <Select value={turno} onChange={handleTurno}>
                {turnos.map(turno => <MenuItem key={turno.value} value={turno.value}>{ turno.label }</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
        </>}
        {(tipoDeUbicacion == 'sala') && <>
          <Grid item sm={2}>
            <FormControl variant="standard" fullWidth>
              <InputLabel>Hora de inicio</InputLabel>
              <Select value={horaInicial}>
                {[{value: '08:30', label: '08:30'}].map(item => <MenuItem value={item.value}>{ item.label }</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
          <Grid item sm={2}>
            <FormControl variant="standard" fullWidth>
              <InputLabel>Duración</InputLabel>
              <Select value={duracion}>
                {[
                  { value: 0.5, label: '00:30' },
                  { value: 1, label: '01:00' },
                ].map(item => <MenuItem value={item.value}>{ item.label }</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
        </>}
          <Grid item sm={2} display="flex" alignItems="end">
            <Button disabled={loading || !habilitadoParaBuscar} variant={!!habilitadoParaBuscar ? "contained" : "outlined"} startIcon={<Search />} onClick={handleBuscar}>Buscar</Button>
          </Grid>
          <Grid container item sm={12}>
            <Typography>Listado de ubicaciones disponibles</Typography>
        </Grid>
        <Grid item sm={12}>
          {disponibles.length === 0
            ? (
            <Typography variant="body2" color="textSecondary">

              No hay ubicaciones disponibles. Presioná "Buscar" para ver opciones.
            </Typography>
            )
            : (sectores.map(([sector, mesas]) => (
              <Accordion key={sector} >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="subtitle1">{sector + ' (' + mesas.reduce((acc,val) => acc+=val.disponibles,0) + ' disponibles)'}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container justifyContent="center" sx={{ mb: 3 }}>
                    {mesas.map((mesa) => {

                      const puestosOrdenados = [...mesa.puestos].sort((a, b) => a.id - b.id);
                      const mitad = Math.ceil(puestosOrdenados.length / 2);
                      const filaA = puestosOrdenados.slice(0, mitad);
                      const filaB = puestosOrdenados.slice(mitad);

                      return (
                        <Grid item xs={12} md={6} key={mesa.id} sx={{ p: 1 }}>
                          <Box
                            sx={{
                              border: '2px solid',
                              borderColor: 'grey.300',
                              borderRadius: 2,
                              p: 1,
                              backgroundColor: '#fafafa'
                            }}
                          >
                            {/* nombre + #puestos */}
                            <Stack direction="row" justifyContent="space-between">
                              <Typography variant="body2" fontWeight="bold" sx={{ mb: 1 }}>
                                {mesa.nombre} ({mesa.puestos.length})
                              </Typography>
                              <IconButton sx={{mt: -1}} onClick={() => handleToggleMesa(mesa)}><DoneAll fontSize="small" /></IconButton>
                            </Stack>

                            {/* fila superior */}
                            <Grid container justifyContent="center" spacing={1} sx={{ mb: 1 }}>
                              {filaA.map((puesto) => {
                                const seleccionado = puestos.some(
                                  (p) => p.id === puesto.id && p.desk_id === mesa.id
                                );
                                return (
                                  <Grid item key={`${mesa.id}-${puesto.id}`}>
                                    <PuestoSquare
                                      mesa={mesa}
                                      puesto={puesto}
                                      isSeleccionado={seleccionado}
                                      onSelect={(p, m) => {
                                        if (!p.habilitado || p.status !== 'FREE') return;
                                        setPuestos((prev) =>
                                          seleccionado
                                            ? prev.filter(
                                                (x) => !(x.id === p.id && x.desk_id === m.id)
                                              )
                                            : [...prev, { ...p, desk_id: m.id, mesaNombre: m.nombre }]
                                        );
                                      }}
                                    />
                                  </Grid>
                                );
                              })}
                            </Grid>

                            {/* fila inferior (invertimos para mostrar 1-2-3 de frente) */}
                            <Grid container justifyContent="center" spacing={1}>
                              {/* {filaB.reverse().map((puesto) => { */}
                              {filaB.map((puesto) => {
                                const seleccionado = puestos.some(
                                  (p) => p.id === puesto.id && p.desk_id === mesa.id
                                );
                                return (
                                  <Grid item key={`${mesa.id}-${puesto.id}`}>
                                    <PuestoSquare
                                      mesa={mesa}
                                      puesto={puesto}
                                      isSeleccionado={seleccionado}
                                      onSelect={(p, m) => {
                                        if (!p.habilitado || p.status !== 'FREE') return;
                                        setPuestos((prev) =>
                                          seleccionado
                                            ? prev.filter(
                                                (x) => !(x.id === p.id && x.desk_id === m.id)
                                              )
                                            : [...prev, { ...p, desk_id: m.id, mesaNombre: m.nombre }]
                                        );
                                      }}
                                    />
                                  </Grid>
                                );
                              })}
                            </Grid>
                          </Box>
                        </Grid>
                      );
                    })}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            ))
            )}
        </Grid>
      </Grid>
    </Paper>
  )
}

export default NuevaReserva;